import { render, staticRenderFns } from "./PickupInfoWrap.vue?vue&type=template&id=8b106e8a&scoped=true"
import script from "./PickupInfoWrap.vue?vue&type=script&lang=js"
export * from "./PickupInfoWrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b106e8a",
  null
  
)

export default component.exports